import { Injectable } from '@angular/core'
import { MbCheckoutReviewNotesAdapter } from './mb-checkout-review-notes.adapter'
import { MbCheckoutReviewModel } from '../../../models'

@Injectable({
  providedIn: 'root',
})
export class MbCheckoutReviewNotesConnector {
  constructor (protected adapter: MbCheckoutReviewNotesAdapter) {
  }

  get (cartID: string) {
    return this.adapter.load(cartID)
  }

  post (form: MbCheckoutReviewModel, cartID: string) {
    return this.adapter.post(form, cartID)
  }
}
